import { Api } from 'utils';

class ProductService {
	
	static get = async (params?: any) => Api.createResponse('client/products',params);
	static create = async (params?: any) => Api.createResponse('client/products/create',params);
	static update = async (params?: any) => Api.createResponse('client/products/update',params);
	static delete = async (params?: any) => Api.createResponse('client/products/delete',params);
	static upload = async (params?: any) => Api.createResponse('client/products/upload',params);
	static getShipping = async (params?: any) => Api.createResponse('client/products/shipping',params);
	static saveShipping = async (params?: any) => Api.createResponse('client/products/save-shipping',params);

}

export default ProductService;